import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outsource-reports',
  templateUrl: './outsource-reports.component.html',
  styleUrls: ['./outsource-reports.component.scss']
})
export class OutsourceReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
